<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>

      <v-card-text>
        <v-form>
          <v-row dense>
            <!-- 検索条件エリア -->
            <v-col cols="3">
              <CompanyInput
                v-if="isEpson"
                :label="$t('ELE0134')"
                value="value"
                @input="onCompanySelect"
                v-model="searchCondition.returnCompanyCd"
              />
              <ManufacturerInput
                v-else
                :label="$t('ELE0134')"
                v-model="searchCondition.returnCompanyCd"
                @input="onCompanySelect"
              />
            </v-col>
            <v-col cols="3">
              <TextFieldInput :label="$t('ELE0049')" v-model="searchCondition.lotNo" />
            </v-col>
            <v-col cols="3">
              <TextFieldInput :label="$t('ELE0031')" v-model="searchCondition.partCd" />
            </v-col>
            <v-col cols="3">
              <TextFieldInput :label="$t('ELE0032')" v-model="searchCondition.partName" />
            </v-col>
          </v-row>

          <v-row align-content="space-between">
            <v-col justify="start" cols="12" md="6">
              <v-row dense align-content="space-between">
                <v-col cols="5">
                  <TextFieldInputWithDatePicker
                    :label="$t('ELE0135')"
                    v-model="searchCondition.returnDateFrom"
                    @input="onDateChanged"
                  />
                </v-col>
                <v-card-text tag="span"> {{ $t('ELE0141') }} </v-card-text>
                <v-col cols="5">
                  <TextFieldInputWithDatePicker
                    :label="$t('ELE0135')"
                    v-model="searchCondition.returnDateTo"
                    @input="onDateChanged"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col justify="end" cols="12" md="6">
              <v-row justify="end">
                <v-card-title>
                  <BtnSearch @click="onClickSearch" />
                </v-card-title>
                <v-card-title>
                  <BtnCsvDownload :label="$t('ELE0075')" fileTitle="return_record" :items="csvContents" />
                </v-card-title>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
              </v-card-title>
              <v-data-table :headers="headers" dense :items="returnRecordList">
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="onInquiryItem(item)" left />
                  <!-- <IconEdit @click="onEditItem(item)" right /> -->
                </template>
                <template v-slot:[`item.returnNo`]="{ item }">
                  <a :href="recordLink + item.returnNo">
                    {{ item.returnNo }}
                  </a>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
    <ReturnRecordDetailDialog
      v-if="selectedData !== null && dialog"
      :dialog.sync="dialog"
      :modalMode="mode"
      :returnNo.sync="selectedData.returnNo"
      :returnCompanyCd.sync="selectedData.returnCompanyCd"
      :lotNo.sync="selectedData.lotNo"
      :partCd.sync="selectedData.partCd"
      :acceptanceQty.sync="selectedData.acceptanceQty"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
// import { ModalMode } from '@/enum'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
// import cloneDeep from 'lodash/cloneDeep'

import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker.vue'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnSave from '@/components/atoms/button/BtnSave'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import DefectGroupDialog from '@/components/organisms/master/dialog/DefectGroupDialog.vue'
import moment from 'moment'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput.vue'
import BtnCsvDownload from '@/components/atoms/button/BtnCsvDownload.vue'
import ReturnRecordDetailDialog from '@/components/organisms/terminal/dialog/ReturnRecordDetailDialog.vue'
import { ModalMode } from '@/enum'
import cloneDeep from 'lodash/cloneDeep'
import CompanyInput from '@/components/atoms/select/CompanyInput.vue'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'

export default {
  name: 'ReturnRecordForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    SelectSingleInput,
    TextFieldInputWithDatePicker,
    DefectGroupDialog,
    Checkbox,
    BtnSearch,
    BtnSave,
    IconEdit,
    IconInquiry,
    TextFieldInput,
    BtnCsvDownload,
    ReturnRecordDetailDialog,
    CompanyInput,
    ManufacturerInput,
  },

  data() {
    return {
      dialog: false,
      mode: ModalMode.EDIT,
      searchCondition: {
        returnCompanyCd: '',
        lotNo: '',
        partCd: '',
        partName: '',
        returnDateFrom: moment().subtract(1, 'M').format('YYYY-MM-DD'),
        returnDateTo: moment(new Date()).format('YYYY-MM-DD'),
      },
      companyList: [],
      headers: [
        { text: '', align: 'center', divider: true, sortable: false, value: 'action' },
        // { text: this.$t('ELE0136'), divider: true, value: 'returnNo' },
        // { text: this.$t('ELE0135'), divider: true, value: 'returnDate' },
        { text: this.$t('ELE0134'), divider: true, value: 'companyName' },
        { text: this.$t('ELE0049'), divider: true, value: 'lotNo' },
        { text: this.$t('ELE0031'), divider: true, value: 'partCd' },
        { text: this.$t('ELE0032'), divider: true, value: 'partName' },
        { text: this.$t('ELE0119'), divider: true, align: 'end', value: 'acceptanceQty' },
        { text: this.$t('ELE0120'), divider: true, align: 'end', value: 'returnQty' },
        { text: this.$t('ELE0121'), divider: true, align: 'end', value: 'returnRate' },
        { text: this.$t('ELE0192'), divider: false, align: 'end', value: 'noOfRecords' },
      ],
      csvContentsEmpty: [
        {
          [this.$t('ELE0136')]: '',
          [this.$t('ELE0135')]: '',
          [this.$t('ELE0281')]: '',
          [this.$t('ELE0282')]: '',
          [this.$t('ELE0049')]: '',
          [this.$t('ELE0031')]: '',
          [this.$t('ELE0032')]: '',
          [this.$t('ELE0119')]: '',
          [this.$t('ELE0120')]: '',
          [this.$t('ELE0121')]: '',
        },
      ],
      csvContents: [],
      returnRecordList: [],
      selectedData: null,
    }
  },
  computed: {
    recordLink: {
      get() {
        return `/edit-return-record?record=`
      },
    },
    isEpson: {
      get() {
        return this.$store.getters.isEpson
      },
    },
  },
  methods: {
    onCompanySelect() {
      // this.onClickSearch()
    },
    onDateChanged() {
      // if (this.searchCondition.returnDateFrom && this.searchCondition.returnDateTo) {
      //   this.onClickSearch()
      // }
    },
    calculateReturnRate(returnQty, acceptanceQty) {
      if (acceptanceQty > 0) {
        return `${parseFloat((returnQty / acceptanceQty) * 100).toFixed(2)}%`
      }
      return ''
    },
    async onClickSearch() {
      this.startLoading()
      try {
        const params = { ...this.searchCondition, userCompanyCd: this.isEpson ? '' : this.$store.getters.companyCd }
        const elements = await API.get('/record/returnRecordSummary', params)
        this.returnRecordList = elements?.map((element) => {
          return {
            // returnNo: element.returnNo,
            // returnDate: element.returnDate,
            returnCompanyCd: element.returnCompanyCd,
            companyName: element.companyName,
            lotNo: element.lotNo,
            partCd: element.partCd,
            partName: element.partName,
            returnQty: element.returnQtySum, //Display Sum of all similar data
            acceptanceQty: element.acceptanceQty ?? '-',
            returnRate: element.returnRate ? `${Number(element.returnRate).toFixed(2)}%` : '-',
            noOfRecords: element.noOfRecords,
          }
        })
        const elementsForCSV = await API.get('/record/returnRecord', params)
        if (elementsForCSV?.length > 0) {
          this.csvContents = elementsForCSV?.map((element) => {
            return {
              [this.$t('ELE0136')]: element.returnNo,
              [this.$t('ELE0135')]: element.returnDate,
              [this.$t('ELE0281')]: element.supplierCd,
              [this.$t('ELE0282')]: element.supplierName,
              [this.$t('ELE0049')]: element.lotNo,
              [this.$t('ELE0031')]: element.partCd,
              [this.$t('ELE0032')]: element.partName,
              [this.$t('ELE0120')]: element.returnQty,
              [this.$t('ELE0054')]: element.remarks,
            }
          })
        } else {
          this.csvContents = this.csvContentsEmpty
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0122') })))
      } finally {
        this.stopLoading()
      }
    },
    onInquiryItem(item) {
      this.selectedData = cloneDeep(item)
      this.dialog = true
    },
  },
  mounted() {
    this.onClickSearch()
  },
}
</script>

<style>
.v-card__text {
  width: auto;
}
</style>
